import { IParlamentarianAddEditRequest } from '../../../../model/sge/parlamentarian/request/parlamentarian-add-edit-request';

export type ParlamentarianCreateEditState = {
    parlamentarianId?: string;
    parlamentarianRequest: IParlamentarianAddEditRequest;
    showValidationErrors: boolean;
};

export enum ACTION_TYPES {
    setParlamentarianId = 'setParlamentarianId',
    setParlamentarianRequest = 'setParlamentarianRequest',
    updateParlamentarianRequest = 'updateParlamentarianRequest',
    updateContact = 'updateContact',
    setShowValidationErrors = 'setShowValidationErrors',
}

export const ParlamentarianCreateEditReducer = (state: ParlamentarianCreateEditState, action: any): ParlamentarianCreateEditState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setParlamentarianId:
            return { ...state, parlamentarianId: payload };
        case ACTION_TYPES.setParlamentarianRequest:
            return { ...state, parlamentarianRequest: payload };
        case ACTION_TYPES.updateParlamentarianRequest:
            return { ...state, parlamentarianRequest: { ...state.parlamentarianRequest, ...payload } };
        case ACTION_TYPES.updateContact:
            return { ...state, parlamentarianRequest: { ...state.parlamentarianRequest, contact: { ...state.parlamentarianRequest.contact, ...payload } } };
        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
